import { L10nConfig } from 'angular-l10n';
import { L10N_TRANSLATION_PROVIDERS } from '@miq/stacking-plan';
import { L10N_REPORTS_TRANSLATION_PROVIDERS } from '@miq/report-export-view';

export const l10nConfig: L10nConfig = {
  format: 'language-region',
  providers: [
    ...L10N_TRANSLATION_PROVIDERS,
    ...L10N_REPORTS_TRANSLATION_PROVIDERS,
    { name: 'app', asset: './assets/locales/locale' },
  ],
  cache: true,
  keySeparator: '.',
  defaultLocale: { language: 'en-US', currency: 'USD' },
  schema: [
    {
      text: 'United States',
      dir: 'ltr',
      locale: {
        language: 'en-US',
        currency: 'USD',
        timeZone: 'America/Los_Angeles',
      },
    },
  ],
};
